import { render, staticRenderFns } from "./ConfirmarEliminarBiometricoDialogComponent.vue?vue&type=template&id=cfac3826"
import script from "./ConfirmarEliminarBiometricoDialogComponent.vue?vue&type=script&lang=js"
export * from "./ConfirmarEliminarBiometricoDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports